import { Component, DestroyRef, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { BoardService } from '../../../../../services/board.service';
import { NotificationService } from '../../../../../services/notifications.service';

@Component({
  selector: 'app-board-v3-card-comments-panel',
  templateUrl: './card-comments-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BoardV3CardCommentsPanelComponent {
  @Input() cardId!: string;
  @Output() commentAdded = new EventEmitter<unknown>();

  private readonly boardService = inject(BoardService);
  private readonly notificationService = inject(NotificationService);
  private readonly destroyRef = inject(DestroyRef);

  commentControl = new FormControl('');
  submittingComment = false;

  submitComment(): void {
    const text = this.commentControl.value?.trim();
    if (!text || this.submittingComment) return;

    this.submittingComment = true;
    this.boardService
      .createComment(this.cardId, { text })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (event) => {
          this.commentControl.setValue('');
          this.submittingComment = false;
          this.commentAdded.emit(event);
        },
        error: () => {
          this.submittingComment = false;
          this.notificationService.showError('', 'Failed to add comment');
        },
      });
  }
}
